var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.tipoComprobante === _vm.codigoFactura
                  ? "Comprobante de compra"
                  : "Nota de crédito"
              )
            )
          ]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.anulado === "S",
                    expression: "anulado === 'S'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.form.cabecera.estado === "A" && _vm.anulado === "N",
                    expression:
                      "form.cabecera.estado === 'A' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.form.cabecera.estado === "N" && _vm.anulado === "N",
                    expression:
                      "form.cabecera.estado === 'N' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "form",
            {
              staticClass: "form-inline",
              attrs: {
                action:
                  _vm.url + "/subir-comprobante-compra/" + _vm.id_comprobante,
                method: "POST",
                enctype: "multipart/form-data"
              },
              on: { submit: _vm.submitFoto }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.form.cabecera.estado !== "N" && _vm.anulado !== "S",
                    expression:
                      "form.cabecera.estado !== 'N' && anulado !== 'S'"
                  }
                ],
                attrs: { type: "file", name: "path_foto", id: "path_foto" }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "_token" },
                domProps: { value: _vm.token }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.cabecera.estado !== "N" && _vm.anulado !== "S",
                      expression:
                        "form.cabecera.estado !== 'N' && anulado !== 'S'"
                    }
                  ],
                  staticClass: "btn-success btn--bigger",
                  attrs: { type: "submit" }
                },
                [
                  _c("i", { staticClass: "fa fa-upload" }),
                  _c("span", [_vm._v("Subir documento(s)")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.cabecera.estado !== "N" &&
                        _vm.path_foto != "" &&
                        _vm.path_foto != null,
                      expression:
                        "form.cabecera.estado !== 'N' && path_foto != '' && path_foto != null"
                    }
                  ],
                  staticClass: "btn-info btn--bigger",
                  attrs: { type: "button" },
                  on: { click: _vm.descargarArchivo }
                },
                [
                  _c("i", { staticClass: "fa fa-download" }),
                  _c("span", [_vm._v("Ver documento(s)")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-bus200 btn--bigger",
                  attrs: {
                    disabled:
                      !_vm.permiteEditarComprobante &&
                      !_vm.permiteAnularComprobante,
                    type: "button"
                  },
                  on: { click: _vm.buscarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Consultar")])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c(
          "div",
          { staticClass: "layout__main-form" },
          [
            _c("cabecera-compra", {
              attrs: {
                codigoFactura: _vm.codigoFactura,
                codigoNotaCredito: _vm.codigoNotaCredito,
                disabled: !_vm.editable,
                errores: _vm.errores,
                monedas: _vm.monedas,
                tipoComprobante: _vm.tipoComprobante
              },
              on: {
                decimalesActualizados: _vm.decimalesActualizados,
                consultarAfectado: _vm.consultarAfectado,
                consultar: _vm.consultar,
                quitarComprobante: _vm.quitarComprobante
              },
              model: {
                value: _vm.form.cabecera,
                callback: function($$v) {
                  _vm.$set(_vm.form, "cabecera", $$v)
                },
                expression: "form.cabecera"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__title" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("input-field", {
                      attrs: {
                        id: "searchItems",
                        placeholder: "Consulta de detalle por descripción..."
                      },
                      model: {
                        value: _vm.searchItems,
                        callback: function($$v) {
                          _vm.searchItems = $$v
                        },
                        expression: "searchItems"
                      }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Detalles del comprobante")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("tabla-detalle-comprobante", {
                    attrs: {
                      decimales_compras: _vm.decimales_compras,
                      tipo: "P",
                      disabled: !_vm.editable,
                      errores: _vm.errores,
                      anulado: _vm.anulado,
                      irbpnr: _vm.irbpnr,
                      tipoComprobante: _vm.tipoComprobante,
                      search: _vm.searchItems
                    },
                    on: { input: _vm.inputDetalles },
                    model: {
                      value: _vm.form.items,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "items", $$v)
                      },
                      expression: "form.items"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoComprobante === _vm.codigoFactura,
                    expression: "tipoComprobante === codigoFactura"
                  }
                ],
                staticClass: "card"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-forma-pago", {
                      attrs: {
                        disabled: !_vm.editable,
                        tiposUnidad: _vm.tiposUnidad,
                        totalComprobante: _vm.form.total,
                        errores: _vm.errores,
                        formasPago: _vm.formasPago
                      },
                      model: {
                        value: _vm.form.formasPago,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "formasPago", $$v)
                        },
                        expression: "form.formasPago"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-xs-12 col-md-7" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card__content" },
                    [
                      _c("tabla-informacion-adicional", {
                        attrs: {
                          disabled: !_vm.editable,
                          errores: _vm.errores
                        },
                        model: {
                          value: _vm.form.informacionAdicional,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "informacionAdicional", $$v)
                          },
                          expression: "form.informacionAdicional"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-5" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "subtotal_sin_impuestos",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.total_sin_impuestos,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "total_sin_impuestos",
                                      $$v
                                    )
                                  },
                                  expression: "form.total_sin_impuestos"
                                }
                              },
                              [
                                _c("span", [_vm._v("Subtotal S/I")]),
                                _vm._v(" "),
                                _vm.errores.total_sin_impuestos
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.total_sin_impuestos[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "descuento_total",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.descuento_total,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "descuento_total", $$v)
                                  },
                                  expression: "form.descuento_total"
                                }
                              },
                              [
                                _c("span", [_vm._v("Descuento total")]),
                                _vm._v(" "),
                                _vm.errores.descuento_total
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.descuento_total[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "subtotal_no_iva",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.subtotal_no_sujeto_iva,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "subtotal_no_sujeto_iva",
                                      $$v
                                    )
                                  },
                                  expression: "form.subtotal_no_sujeto_iva"
                                }
                              },
                              [
                                _c("span", [_vm._v("Subtotal N/IVA")]),
                                _vm._v(" "),
                                _vm.errores.subtotal_no_sujeto_iva
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores
                                                .subtotal_no_sujeto_iva[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "subtotal_e_iva",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.subtotal_exento_iva,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "subtotal_exento_iva",
                                      $$v
                                    )
                                  },
                                  expression: "form.subtotal_exento_iva"
                                }
                              },
                              [
                                _c("span", [_vm._v("Subtotal E/I")]),
                                _vm._v(" "),
                                _vm.errores.subtotal_exento_iva
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.subtotal_exento_iva[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "total_irbpnr",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.total_irbpnr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "total_irbpnr", $$v)
                                  },
                                  expression: "form.total_irbpnr"
                                }
                              },
                              [
                                _c("span", [_vm._v("Total IRBPNR")]),
                                _vm._v(" "),
                                _vm.errores.total_irbpnr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.total_irbpnr[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "subtotal_iva",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.subtotal_iva,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "subtotal_iva", $$v)
                                  },
                                  expression: "form.subtotal_iva"
                                }
                              },
                              [
                                _c("span", [_vm._v("Subtotal IVA")]),
                                _vm._v(" "),
                                _vm.errores.subtotal_iva
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.errores.subtotal_iva[0])
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "subtotal_iva_0",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.subtotal_iva_0,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "subtotal_iva_0", $$v)
                                  },
                                  expression: "form.subtotal_iva_0"
                                }
                              },
                              [
                                _c("span", [_vm._v("Subtotal IVA 0%")]),
                                _vm._v(" "),
                                _vm.errores.subtotal_iva_0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.subtotal_iva_0[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "iva",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.iva,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "iva", $$v)
                                  },
                                  expression: "form.iva"
                                }
                              },
                              [
                                _c("span", [_vm._v("IVA")]),
                                _vm._v(" "),
                                _vm.errores.iva
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.iva[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "ice",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.ice,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ice", $$v)
                                  },
                                  expression: "form.ice"
                                }
                              },
                              [
                                _c("span", [_vm._v("ICE")]),
                                _vm._v(" "),
                                _vm.errores.ice
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.ice[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  vMoney: "",
                                  format: _vm.money,
                                  id: "total",
                                  placeholder: "$ #,###.##",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.form.total,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "total", $$v)
                                  },
                                  expression: "form.total"
                                }
                              },
                              [
                                _c("span", [_vm._v("Total")]),
                                _vm._v(" "),
                                _vm.errores.total
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.total[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.anulado !== "S",
                      expression: "anulado !== 'S'"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      !_vm.editable ||
                      !_vm.permiteCrearComprobante ||
                      !_vm.permiteEditarComprobante ||
                      _vm.anulado === "S"
                  },
                  on: { click: _vm.guardarComprobanteCompra }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: {
                    disabled: !_vm.permiteCrearComprobante,
                    type: "button"
                  },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.form.cabecera.estado !== "N" && _vm.anulado === "N",
                      expression:
                        "form.cabecera.estado !== 'N' && anulado === 'N'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: {
                    disabled: !_vm.permiteAnularComprobante,
                    type: "button"
                  },
                  on: { click: _vm.anularComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.cabecera.estado !== "N",
                      expression: "form.cabecera.estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.cabecera.estado !== "N",
                      expression: "form.cabecera.estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.mostrarAbonos }
                },
                [
                  _c("i", { staticClass: "fa fa-money" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Abonos")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-bus300 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v("Anterior\n                ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-bus300 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v("Siguiente\n                ")
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "70%",
            name: "coincidenciaComprobantes",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("coincidencia-comprobantes", {
            attrs: { comprobantes: _vm.comprobantesConsultados },
            on: {
              seleccionar: _vm.seleccionarComprobanteAfectado,
              cerrar: function($event) {
                return _vm.$modal.hide("coincidenciaComprobantes")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "comprobantes",
            height: "auto",
            width: "80%",
            scrollable: ""
          }
        },
        [
          _c("lista-comprobantes-compra", {
            attrs: { tipoComprobante: _vm.tipoComprobanteConsulta },
            on: { selected: _vm.selectedComprobante }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            adaptive: "",
            resizable: "",
            reset: "",
            name: "abonosCompra",
            height: "auto",
            width: "80%",
            scrollable: ""
          }
        },
        [_c("abonos-compra", { attrs: { idComprobante: _vm.id_comprobante } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Formas de pago")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales del comprobante")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-632edc9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632edc9e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/ComprobanteCompra.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-632edc9e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/ComprobanteCompra.vue
// module chunks = 0